module.exports = __webpack_public_path__ + "img/48.4726df88.svg";